export default "__VITE_ASSET__xft1zjO2__"